import React, { useState } from "react";
import SearchResult from "../components/Carrer/SearchResult";

import Aside from "../modules/SideNav/Aside";

function SearchResultsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <SearchResult handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default SearchResultsLayout;
